import { api } from "@/lib/api-client";
import type { Team, TeamWithMembers, TeamsListResponse } from "@/types/teams";

export async function getTeams(params?: {
  search?: string;
  page?: number;
  perPage?: number;
}): Promise<TeamsListResponse> {
  const query = new URLSearchParams();
  if (params?.search) query.set("search", params.search);
  if (params?.page) query.set("page", String(params.page));
  if (params?.perPage) query.set("per_page", String(params.perPage));
  const qs = query.toString();
  return api<TeamsListResponse>(`/api/teams${qs ? `?${qs}` : ""}`);
}

export async function getTeam(teamId: string): Promise<TeamWithMembers> {
  return api<TeamWithMembers>(`/api/teams/${teamId}`);
}

export async function removeTeamMember(teamId: string, userId: string) {
  return api<unknown>(`/api/teams/${teamId}/members/${userId}`, {
    method: "DELETE",
  });
}

export type { Team, TeamWithMembers };
